import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { FETCH_COMPONENTS_REASON } from '../../common/constants/fetch-components-reason.tsx';
import type { OrderField, OrderDirection } from '../../query-param-adapter/model/order.tsx';
import { getComponentsPageRequest } from '../../state/actions.tsx';
import {
	getAris as getComponentAris,
	getIds as getComponentIds,
	getTotalItems,
} from '../../state/components/selectors.tsx';
import { patchQuery } from '../../state/query/actions.tsx';
import { getOrderDirection, getOrderField } from '../../state/query/selectors.tsx';
import type { State } from '../../state/reducer.tsx';
import { isLoading as isPageLoading } from '../../state/ui/page/selectors.tsx';
import CompassComponentsTable from './view.tsx';

const mapStateToProps = (state: State) => ({
	isPageLoading: isPageLoading(state),

	// Ordered list of IDs returned from backend. Needed for rendering sorted order.
	componentIds: getComponentIds(state),

	// Used to quickly fire search query.
	componentAris: getComponentAris(state),

	// Needed to retrieve component by ARI and render.
	componentsById: state.components.byId,

	componentCount: getTotalItems(state),
	orderField: getOrderField(state),
	orderDirection: getOrderDirection(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	onSort: ({ key, sortOrder }: { key: OrderField; sortOrder: OrderDirection }) => {
		dispatch(
			patchQuery({
				orderDirection: sortOrder,
				orderField: key,
				page: 1,
			}),
		);
		dispatch(
			getComponentsPageRequest({
				page: 1,
				initiatedBy: FETCH_COMPONENTS_REASON.SORTING,
			}),
		);
	},
});

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { RequestAccessState } from './request-access-state';
export default connect(mapStateToProps, mapDispatchToProps)(CompassComponentsTable);
